import type React from 'react';
import { useCallback } from 'react';
import {
	useFeedbackCollectorActions,
	type FeedbackCollectorProps,
} from '@atlassian/jira-feedback-collector';
import { useIntl } from '@atlassian/jira-intl';
import {
	type NAV4_OPT_OUT_FEEDBACK_GROUP_ID,
	type NAV4_SIDEBAR_FEEDBACK_GROUP_ID,
	ENTRYPOINT_ID_NAV4,
} from '../../constants';
import { messages } from './messages';

type Params = Pick<FeedbackCollectorProps, 'feedbackContext'> & {
	feedbackGroupId: typeof NAV4_OPT_OUT_FEEDBACK_GROUP_ID | typeof NAV4_SIDEBAR_FEEDBACK_GROUP_ID;
};

export function useNav4FeedbackCollector(params: Params) {
	const { feedbackGroupId, feedbackContext } = params;
	const { formatMessage } = useIntl();

	const { openFeedbackCollector, closeFeedbackCollector } = useFeedbackCollectorActions();

	const showFeedbackCollector = useCallback(
		(feedbackTitleDetails: React.ReactNode = null) => {
			const _feedbackTitleDetails =
				feedbackTitleDetails ?? formatMessage(messages.feedbackTitleDetailsNonFinal);

			openFeedbackCollector({
				feedbackGroupId,
				entrypointId: ENTRYPOINT_ID_NAV4,
				feedbackContext,
				feedbackTitle: formatMessage(messages.feedbackTitleNonFinal),
				feedbackTitleDetails: _feedbackTitleDetails,
			});
		},
		[formatMessage, feedbackContext, feedbackGroupId, openFeedbackCollector],
	);

	return { showFeedbackCollector, closeFeedbackCollector };
}
